<div class="alert_banner" [ngClass]="getBannerClass()">
  <app-spark-icon [icon]="type" size="24"></app-spark-icon>
  <div>
    @if (header) {
      <header>
        <span>{{ header }}</span>
      </header>
    }
    @if (message) {
      <p [innerHTML]="message"></p>
    }
    @if (buttonName) {
      <footer>
        <app-button matSnackBarAction type="primary" [size]="'small'" (buttonClick)="handleButtonClick()">
          {{ buttonName }}
        </app-button>
      </footer>
    }
  </div>
</div>